import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Youtube, Mail, MapPin, Phone } from 'lucide-react';
import { CONTACT_INFO } from '../mock/mock';

const Footer = () => {
  return (
    <footer className="bg-[#1a1614] text-[#e8dfd1] mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <img
              src="https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/jboyka5i_RCD%20logo.jpg"
              alt="RCD"
              className="h-16 w-auto object-contain bg-[#faf6f0] p-1 rounded-full"
            />
            <div className="flex flex-col leading-none">
              <h3 className="font-serif text-2xl text-[#faf6f0]">RCD</h3>
              <span className="text-[10px] tracking-[0.24em] text-[#b8945a] uppercase mt-1.5">
                Rajdhani Crafts & Daughters
              </span>
            </div>
          </div>
          <p className="text-sm leading-relaxed text-[#c9bfae] max-w-xs mt-5">
            Rajdhani Crafts &amp; Daughters is a Jaipur-based, family-led manufacturer of bespoke furniture and engineered wood flooring, shaped by a family legacy in wood that began in 1964.
          </p>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-5 text-[#faf6f0]">Explore</h4>
          <ul className="space-y-3 text-sm">
            {[
              { to: '/about',          label: 'About RCD' },
              { to: '/about/history',  label: 'History' },
              { to: '/about/founder',  label: 'Family Leadership' },
              { to: '/about/clients',  label: 'Clients' },
              { to: '/products',       label: 'Products' },
              { to: '/our-plant',      label: 'Our Plant' },
              { to: '/trade-fairs',    label: 'Trade Fairs' },
              { to: '/contact',        label: 'Contact' }
            ].map(l => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-explore-${l.to.replace(/\//g, '').replace('about', 'about-') || 'home'}`}
                  className="rcd-link text-[#c9bfae] hover:text-[#faf6f0]"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-5 text-[#faf6f0]">Reach Us</h4>
          <ul className="space-y-4 text-sm text-[#c9bfae]">
            <li className="flex gap-3"><MapPin size={16} className="mt-0.5 text-[#b8945a] flex-shrink-0" /><span>{CONTACT_INFO.address}</span></li>
            <li className="flex gap-3"><Phone size={16} className="mt-0.5 text-[#b8945a] flex-shrink-0" /><span>{CONTACT_INFO.phone}</span></li>
            <li className="flex gap-3"><Mail size={16} className="mt-0.5 text-[#b8945a] flex-shrink-0" /><span>{CONTACT_INFO.email}</span></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-5 text-[#faf6f0]">Follow the Craft</h4>
          <div className="flex gap-3">
            {[
              { icon: Instagram, href: CONTACT_INFO.socials.instagram, label: 'Instagram' },
              { icon: Linkedin, href: CONTACT_INFO.socials.linkedin, label: 'LinkedIn' },
              { icon: Youtube, href: CONTACT_INFO.socials.youtube, label: 'YouTube' }
            ].map(({ icon: Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
                className="w-10 h-10 flex items-center justify-center border border-[#3a2f27] text-[#c9bfae] hover:border-[#b8945a] hover:text-[#b8945a] transition-colors"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
          <p className="text-xs mt-6 text-[#8a7f6f]">{CONTACT_INFO.hours}</p>
        </div>
      </div>

      <div className="border-t border-[#2b241f]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#8a7f6f]">© {new Date().getFullYear()} Rajdhani Crafts and Daughters Pvt. Ltd. All rights reserved.</p>
          <p className="text-xs text-[#8a7f6f] tracking-[0.24em] uppercase">Made in Jaipur · Shaped by legacy · Built for what comes next</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
